<button type="button"
        [class.active]="active"
        [class.has-icon]="icon"
        [class.has-text]="label"
        [disabled]="disabled"
        (click)="tabActivated.emit(identifier || label)">
    <span>{{ label }}</span>
    @if (icon) {
        <ws-ace-icon [glyph]="icon"></ws-ace-icon>
    }
</button>
